import fetchLoyaltyAccountActivity from 'actions/loyalty/fetchLoyaltyAccountActivity'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyArray } from 'lib/array/arrayUtils'
import { LOYALTY_ACTIVITIES_DEFAULT_END_DATE, LOYALTY_ACTIVITIES_DEFAULT_START_DATE } from 'loyalty/constants/loyaltyConfig'
import { useCallback, useEffect, useRef } from 'react'

function useCurrentLoyaltyActivities(): [
  activities: Array<App.LoyaltyAccountActivity>,
  fetching: boolean,
  hasNextPage: boolean,
  loadMore: () => void,
  error: any,
] {
  const dispatch = useAppDispatch()
  const pageRef = useRef(1)

  const accountActivity = useAppSelector(state => state.loyalty.accountActivity)
  useEffect(() => {
    pageRef.current = 1
    dispatch(fetchLoyaltyAccountActivity(LOYALTY_ACTIVITIES_DEFAULT_START_DATE, LOYALTY_ACTIVITIES_DEFAULT_END_DATE, 1, 1))
  }, [dispatch])

  const loadMore = useCallback(() => {
    pageRef.current += 1
    const nextAbsoluteIndex = accountActivity.data?.nextAbsoluteIndex
    dispatch(fetchLoyaltyAccountActivity(LOYALTY_ACTIVITIES_DEFAULT_START_DATE, LOYALTY_ACTIVITIES_DEFAULT_END_DATE, pageRef.current, nextAbsoluteIndex))
  }, [dispatch, accountActivity.data?.nextAbsoluteIndex])

  return [
    accountActivity.data?.activities ?? EmptyArray,
    !!accountActivity.fetching,
    accountActivity.data?.hasNextPage ?? false,
    loadMore,
    accountActivity.error,
  ]
}

export default useCurrentLoyaltyActivities
